import { forwardRef, isValidElement } from "react";
import type { IconsaxComponent } from "../../../../../Iconsax/Iconsax.types.js";
import { ICONSAX_SIZE } from "../../../../../Iconsax/Iconsax.types.js";
import { useSidebar } from "../../../../Sidebar.context.js";
import { SidebarItemText } from "../SidebarItemBody/style.js";
import { StyledSidebarSubMenuItem, SubMenuContainer, SubMenusDiv, VerticalLine } from "./style.js";
import { SidebarItemSubMenuProps } from "./types.js";

const renderIcon = (icon: Exclude<SidebarItemSubMenuProps["subMenu"], undefined>["entries"][number]["icon"]) => {
    if (!isValidElement(icon) && icon) {
        const IconComponent = icon as IconsaxComponent;
        return <IconComponent size={ICONSAX_SIZE.SMALL} />;
    }
    return isValidElement(icon) ? icon : null;
};
export const SidebarItemSubMenu = forwardRef<HTMLDivElement, SidebarItemSubMenuProps>(
    ({ subMenu, onClick, selectedKey, ...attributes }, ref): JSX.Element | null => {
        const { transitionState, transitionDuration } = useSidebar();

        if (!subMenu || subMenu.entries.length === 0) return null;

        return (
            <SubMenuContainer
                {...attributes}
                ref={ref}
                isOpen={!!subMenu.isOpen}
                transitionState={transitionState}
                transitionDuration={transitionDuration}
            >
                <VerticalLine />
                <SubMenusDiv>
                    {subMenu.entries.map(({ label, icon, disabled, id, ...subProps }) => {
                        return (
                            <StyledSidebarSubMenuItem
                                disabled={disabled}
                                key={id}
                                onClick={(event) => {
                                    onClick(
                                        {
                                            label,
                                            icon,
                                            disabled,
                                            id,
                                            ...subProps,
                                        },
                                        event,
                                    );
                                }}
                                onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                        onClick(
                                            {
                                                label,
                                                icon,
                                                disabled,
                                                id,
                                                ...subProps,
                                            },
                                            event,
                                        );
                                    }
                                }}
                                selected={selectedKey === id}
                            >
                                {icon && renderIcon(icon)}
                                <SidebarItemText isOpen={subMenu.isOpen} transitionState={transitionState} transitionDuration={transitionDuration}>
                                    {label}
                                </SidebarItemText>
                            </StyledSidebarSubMenuItem>
                        );
                    })}
                </SubMenusDiv>
            </SubMenuContainer>
        );
    },
);
